module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "casebg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n                Quooker Skandinavien A/S\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Webshop - iOS applikation\n            ")])])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-light skew-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h3', [_vm._v("Udfordringen")]), _vm._v(" "), _c('p', [_vm._v("Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "infocard"
  }, [_c('h3', [_vm._v("Teknologier:")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Frontend")]), _vm._v(" "), _c('p', [_vm._v("JavaScript - Vue.js")]), _vm._v(" "), _c('h5', [_vm._v("Backend")]), _vm._v(" "), _c('p', [_vm._v("PHP - Laravel")]), _vm._v(" "), _c('h5', [_vm._v("Server")]), _vm._v(" "), _c('p', [_vm._v("Microsoft Azure VPS")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "solution"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 image"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 body-wrapper"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('h3', [_vm._v("Løsningen")]), _vm._v(" "), _c('p', [_vm._v("Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. ")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "result"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 body-wrapper light"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('h3', [_vm._v("Resultatet")]), _vm._v(" "), _c('p', [_vm._v("Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 image"
  })])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Udtalelse her\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-037e86c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/case/pages/quooker.vue
// module id = 298
// module chunks = 1